var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer py-2 py-lg-0 my-5 d-flex flex-lg-column",attrs:{"id":"kt_footer"}},[_c('div',{staticClass:"d-flex flex-column flex-md-row align-items-center justify-content-between",class:{ 'container-fluid': _vm.widthFluid, container: !_vm.widthFluid }})])
}
var staticRenderFns = []

export { render, staticRenderFns }